import React, { useState, useEffect } from 'react';
import { Grid, Paper, Typography, Button, Box, Checkbox, FormControlLabel, Slider, Select, MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase-config';

const Rentals = () => {
  const [priceRange, setPriceRange] = useState([0, 200]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [transmission, setTransmission] = useState('');
  const [city, setCity] = useState('');
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRentals = async () => {
      try {
        const q = query(
          collection(db, 'ads'),
          where('adType', '==', 'rent'),
          where('status', '!=', 'sold')
        );
        const querySnapshot = await getDocs(q);
        console.log("Fetched rentals count:", querySnapshot.size);
        const rentalsData = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          console.log("Rental data:", data);

          return {
            id: doc.id,
            ...data,
            mileage: typeof data.mileage === 'number' ? `${data.mileage} km` : 'N/A'
          };
        });
  
        rentalsData.sort((a, b) =>
          a.isPremium === b.isPremium ? 0 : a.isPremium ? -1 : 1
        );
        setRentals(rentalsData);
      } catch (error) {
        console.error('Error fetching rentals:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchRentals();
  }, []);
  

  const carTypes = ['Седан', 'SUV', 'Хечбек', 'Купе', 'Кабриолет'];
  const cities = [
    'Скопје', 'Битола', 'Прилеп', 'Куманово', 'Тетово', 'Охрид', 'Велес', 'Штип', 'Кавадарци', 'Гостивар',
    'Струмица', 'Неготино', 'Кочани', 'Кичево', 'Ресен', 'Гевгелија', 'Струга', 'Делчево', 'Виница', 'Кратово',
    'Крива Паланка', 'Берово', 'Македонски Брод', 'Дебар', 'Демир Капија', 'Демир Хисар', 'Пробиштип', 'Свети Николе',
    'Валандово', 'Богданци', 'Пехчево', 'Радовиш', 'Теарце', 'Желино', 'Липково', 'Чаир', 'Аеродром', 'Гази Баба',
    'Карпош', 'Кисела Вода', 'Центар', 'Ѓорче Петров', 'Сарај', 'Студеничани', 'Арачиново', 'Сопиште', 'Зелениково',
    'Илинден', 'Петровец', 'Чучер-Сандево', 'Зрновци', 'Маврово и Ростуше', 'Ранковце', 'Лозово', 'Новци', 'Новаци',
    'Конче', 'Дојран', 'Василево', 'Босилово', 'Ново Село', 'Карачиново', 'Куклиш', 'Могила', 'Пласница', 'Центар Жупа'
  ];
  const transmissions = ['Автоматски', 'Мануелен'];
  const brands = [
    'BMW', 'Mercedes', 'Volkswagen', 'Peugeot',
    'Abarth', 'Acura', 'Alfa Romeo', 'Apollo', 'Ariel', 'Aston Martin', 'Audi',
    'BAIC', 'Bentley', 'Borgward', 'Brilliance', 'Bugatti', 'Buick', 'BYD',
    'Cadillac', 'Changan', 'Chery', 'Chevrolet', 'Chrysler', 'Citroen', 'Cupra',
    'Dacia', 'Daewoo', 'Daihatsu', 'Datsun', 'De Tomaso', 'Dodge', 'DS Automobiles',
    'Ferrari', 'Fiat', 'Fisker', 'Ford', 'Geely', 'Genesis', 'GMC', 'Great Wall', 'Haval',
    'Honda', 'Hongqi', 'Hummer', 'Hyundai', 'Infiniti', 'Isuzu', 'JAC', 'Jaguar', 'Jeep',
    'Jetour', 'Kia', 'Koenigsegg', 'Lada', 'Lamborghini', 'Lancia', 'Land Rover', 'Leapmotor',
    'Lexus', 'Lifan', 'Lincoln', 'Lucid', 'Mahindra', 'Maserati', 'Maybach', 'Mazda', 'McLaren',
    'MG', 'Mini', 'Mitsubishi', 'Nio', 'Nissan', 'Opel', 'Pagani', 'Polestar', 'Pontiac',
    'Porsche', 'Proton', 'Qoros', 'Ram', 'Ravon', 'Renault', 'Rezvani', 'Rimac', 'Roewe',
    'Rolls-Royce', 'Saab', 'Seat', 'Seres', 'Skoda', 'Smart', 'SsangYong', 'Subaru', 'Suzuki',
    'Tata', 'Tesla', 'Toyota', 'VinFast', 'Volvo', 'Wey', 'Wuling', 'Xpeng', 'Yugo', 'Zotye'
  ];

  const filteredRentals = rentals.filter(car => {
    const price = typeof car.dailyPrice === 'number' ? car.dailyPrice : 0;
    return (
      price >= priceRange[0] && price <= priceRange[1] &&
      (selectedTypes.length === 0 || selectedTypes.includes(car.carBodyType)) &&
      (!city || car.city === city) &&
      (!transmission || car.transmission === transmission)
    );
  });

  if (loading) {
    return <Typography>Се вчитува...</Typography>;
  }

  return (
    <div className="rentals-page">
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <Typography variant="h4" gutterBottom>Автомобили за изнајмување</Typography>
        
        <Grid container spacing={4}>
          <Grid item xs={12} md={3}>
            <Paper sx={{ p: 2, position: 'sticky', top: '20px' }}>
              <Typography variant="h6" gutterBottom>Филтри</Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography gutterBottom>Цена по ден (€)</Typography>
                <Slider
                  value={priceRange}
                  onChange={(e, newValue) => setPriceRange(newValue)}
                  valueLabelDisplay="auto"
                  min={0}
                  max={200}
                  step={10}
                />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>{priceRange[0]} €</Typography>
                  <Typography>{priceRange[1]} €</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography gutterBottom>Тип на автомобил</Typography>
                {carTypes.map((type) => (
                  <FormControlLabel
                    key={type}
                    control={
                      <Checkbox 
                        checked={selectedTypes.includes(type)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedTypes([...selectedTypes, type]);
                          } else {
                            setSelectedTypes(selectedTypes.filter(t => t !== type));
                          }
                        }}
                      />
                    }
                    label={type}
                  />
                ))}
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography gutterBottom>Град</Typography>
                <Select
                  fullWidth
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="">Сите градови</MenuItem>
                  {cities.map((city) => (
                    <MenuItem key={city} value={city}>{city}</MenuItem>
                  ))}
                </Select>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography gutterBottom>Менувач</Typography>
                <Select
                  fullWidth
                  value={transmission}
                  onChange={(e) => setTransmission(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="">Сите типови</MenuItem>
                  {transmissions.map((trans) => (
                    <MenuItem key={trans} value={trans}>{trans}</MenuItem>
                  ))}
                </Select>
              </Box>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={9}>
            <Typography variant="h5" gutterBottom sx={{ mt: 2 }}>
              {filteredRentals.length} {filteredRentals.length === 1 ? 'автомобил' : 'автомобили'} пронајдени
            </Typography>
            <Grid container spacing={3}>
              {filteredRentals.map((car) => (
                <Grid item xs={12} sm={6} md={4} key={car.id}>
                  <Paper sx={{ p: 2, height: '100%', border: car.isUrgent ? '2px solid red' : 'none' }}>
                    <Box sx={{ height: '150px', bgcolor: '#f5f5f5', mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {car.images?.[0] ? (
                        <img 
                        src={car.images[car.coverPhotoIndex || 0]} 
                          alt={car.model} 
                          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                        />
                      ) : (
                        <Typography>Нема слика</Typography>
                      )}
                    </Box>
                    <Typography variant="h6">{car.brand} {car.model}</Typography>
                    <Typography color="primary" sx={{ fontWeight: 'bold' }}>
  {car.dailyPrice ? `${car.dailyPrice} €/ден` : 'N/A'}
</Typography>

                    <Typography variant="body2">Минимален период: {car.minRentalPeriod || 1} денови</Typography>
                    <Typography variant="body2">{car.city} • {car.transmission}</Typography>
                    <Button 
                      component={Link}
                      to={`/cars/${car.id}`}
                      variant="outlined" 
                      fullWidth 
                      sx={{ mt: 2 }}
                    >
                      Види детали
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default Rentals;